import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { ButtonPrimary, IconAgent } from '@klarna/bubble-ui'
import { hooks as i18nHooks } from 'mage-i18n'
import { useHelpContext } from '../../hooks'

SupportButton.propTypes = {
  analyticsCategory: PropTypes.string.isRequired,
  scrollIntoView: PropTypes.bool,
  onClick: PropTypes.func,
  shouldRedirectToSupportHelpbot: PropTypes.bool
}

export default function SupportButton ({ analyticsCategory, scrollIntoView = false, onClick = null, shouldRedirectToSupportHelpbot = false }) {
  const t = i18nHooks.useTranslator()
  const { navigation } = useHelpContext()
  const ref = useRef()

  useEffect(() => {
    if (ref.current && scrollIntoView) {
      ref.current.scrollIntoView()
    }
  }, [ref.current])

  return (
    <div ref={ref}>
      <ButtonPrimary
        data-testid='hqm-support-button'
        size='medium'
        icon={IconAgent}
        onClick={handleClick}
      >
        {t('help-tool.support-button')}
      </ButtonPrimary>
    </div>
  )

  function handleClick () {
    onClick && onClick()
    shouldRedirectToSupportHelpbot ? navigation.push('supportHelpbot') : navigation.push('support')
  }
}
